import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_kitchen_tabletop: FaireCategoryEntity = {
  token: "catalog_cat_kitchen-tabletop",
  type: "category",
  name: "Kitchen & tabletop",
  count: 962,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
